import { render, staticRenderFns } from "./Settings_Publisher.vue?vue&type=template&id=529a01c1&scoped=true"
import script from "./Settings_Publisher.vue?vue&type=script&lang=js"
export * from "./Settings_Publisher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529a01c1",
  null
  
)

export default component.exports